export default class RawdhaModel {
  designation;
  date = new Date();
}
